export default "__VITE_ASSET__DCJW_$Vo__"